module.exports = __webpack_public_path__ + "media/images/para-93d0abb8d8b0b28f41032cbe73d2f931.png";